<template>
  <div>
    <div class="banner">
      <video v-if="!isMobile()" autoplay muted loop class="video">
        <source src="https://unu-oss.oss-cn-hongkong.aliyuncs.com/home/hk_background.mp4" type="video/mp4"/>
      </video>
      <img v-else src="../../../assets/images/home/homeBackgroundImage.jpg" class="homeBackgroundImage" width="100vw">
      <div class="inner">
        <el-row type="flex" justify="center">
        <el-col class="search-bar" :span="24" :xs="2">
          <a class="fr btn-search" @click="toSearch">{{$t('search')}}</a>
          <div class="search-input">
            <input type="text" :placeholder="$t('EnterWhereYouWantToGo')" v-model.trim="keyword" @keyup.enter="toSearch"/>
          </div>
        </el-col>
        </el-row>

        <el-row type="flex" justify="center">
        <el-col class="sub-nav" :span="24" :xs="6">
          <router-link :to="{name:'ThemeTravel',query:{classification:'qzt'}}">{{$t('parentChild')}}</router-link>
          <router-link :to="{name:'ThemeTravel',query:{classification:'yxt'}}">{{$t('studyTour')}}</router-link>
          <router-link :to="{name:'ThemeTravel',query:{classification:'cxt'}}">{{$t('Meditation')}}</router-link>
          <router-link :to="{name:'ThemeTravel',query:{classification:'syt'}}">{{$t('photography')}}</router-link>
        </el-col>
        </el-row>
      </div>
    </div>
    <div class="ad1">
      <span class="item">{{$t('Multiple products')}}</span>
      <span class="item">{{$t('Delightful service')}}</span>
      <span class="item">{{$t('Global coverage')}}</span>
    </div>
    <div class="ad2">
      <span v-html="$t('Free quote for group travel')"></span>
      <a class="btn-group-quote" href="javascript:;" @click="toGroupQuote">{{$t('GroupQuote')}}</a>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  // Detect if the user's device is Desktop or Mobile
  var mixinDetectingMobile = {
    methods: {
      isMobile: function() {
        var check = false;
        (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      }
    }
  };

  export default {
    name: 'Banner',
    props: ['banners'],
    data() {
      return {
        keyword: ''
      };
    },
    computed: {...mapGetters(['token'])},
    mixins: [mixinDetectingMobile],
    methods: {
      toGroupQuote() {
        let routerName = 'Login';
        if (this.token) {
          routerName = 'UserQuote';
        }
        this.$router.push({name: routerName});
      },
      // 跳转到搜索页面
      toSearch() {
        this.$router.push({name: 'Search', query: {keyword: this.keyword}});
        this.keyword = '';
      }
    }
  };
</script>
<style scoped lang="less">
  .banner{
    position:relative;height:500px;
    > .inner{position:absolute;top:250px;left:50%;z-index:10;transform:translateX(-50%);}
    .banner-item{display:block;width:100%;height:100%;background-repeat:no-repeat;background-position:center center;background-size:cover;cursor:pointer;}
  }
  .h3{padding-top:188px;text-align:center;text-shadow:3px 2px 0 #fff;color:#ff6f61;font-size:48px;font-weight:bold;}
  .search-bar{width:360px;margin:0 auto;overflow:hidden;background-color:#fff;border-radius:4px;}
  .search-input{
    margin-right:120px;padding:0 20px;
    input{width:100%;height:60px;border:none;font-size:16px;}
  }
  .btn-search{display:block;width:120px;text-align:center;line-height:60px;color:#fff;font-size:16px;background-color:#ff6f61;}
  .sub-nav{
    max-width: 100%;margin-top:20px;text-align:center;font-size:0;
    a{
      display:inline-block;width:120px;margin:5px 5px;line-height:60px;color:#fff;font-size:16px;background-color:#ff6f61;background-color:rgba(255, 111, 97, 0.5);border-radius:4px;
      &:hover{background-color:#ff6f61;transition:all 0.3s;box-shadow:0 0 8px #aaa;}
      &:nth-child(even){
        background-color:#fad7a1;background-color:rgba(250, 215, 161, 0.8);
        &:hover{background-color:#fad7a1;}
      }
    }
  }
  .ad1{
    height:40px;text-align:center;font-size:0;background-color:rgba(255, 111, 97, 0.1);
    .item{
      display:inline-block;position:relative;margin:0 60px;padding-left:26px;line-height:40px;color:#321908;font-size:14px;
      &:after{position:absolute;top:12px;left:0;width:16px;height:16px;background-color:#fff;border-radius:50%;content:'';}
    }
  }
  .ad2{
    height:120px;text-align:center;background-image:linear-gradient(45deg, #fad7a1 0%, #fe6f60 100%);
    &:after{display:inline-block;height:100%;vertical-align:middle;content:'';}
    span{display:inline-block;text-align:left;vertical-align:middle;color:#fff;font-size:24px;font-weight:bold;}
  }
  .btn-group-quote{display:inline-block;width:106px;height:40px;margin-left:310px;line-height:38px;vertical-align:middle;color:#fff;font-size:16px;border:1px solid #fff;border-radius:4px;}
  .video{
    min-width: 100%;
    height: 500px;
    object-fit: cover;
  }
  .homeBackgroundImage{
    min-width: 100%;
    height: 500px;
    object-fit: cover;
  }

@media only screen and (max-width: 768px) {
    .ad1 {
        height:100%;
        margin:auto;
    }
     .video {
        max-width:100%;
        height:100%;
        margin:auto;
    }
      .sub-nav {
        width: 300px;
    }
    .ad2{
      max-width:100%;
      margin:auto;
    }
    .btn-group-quote{
        margin-left: 100px;
    }
   }

</style>
